
import React, {FC, useRef} from 'react';
import {useToggle} from 'hooks/useToggle';
import {ImageConfig} from 'templates/reports/Section/ScanImages/useColors';

import PickerIcon from './svgs/picker.inline.svg';
import Picker from './Picker';

import * as styles from './styles.module.scss';

type ColorableProps = {
	children: React.ReactNode;
	config: ImageConfig
}

const Colorable: FC<ColorableProps> = ({children, config}) => {
	const {open, toggle} = useToggle(false);
	const iconRef = useRef<HTMLDivElement>(null);

	return (
		<div className={styles.wrapper}>
			<div className={styles.layer}>
				<div ref={iconRef} className={styles.icon} onClick={toggle}>
					<PickerIcon />
					<div
						className={styles.selected}
						style={{
							backgroundColor: config.fillStyle(1, {
								scale: 1,
							}),
						}}
					/>
				</div>
				{open && (
					<Picker
						iconRef={iconRef}
						toggle={toggle}
						{...config}
					/>
				)}
			</div>
			{children}
		</div>
	);
};

export default Colorable;
